module.exports = __webpack_public_path__ + "img/welfare-ico-2.246e1360.png";